import {HttpError} from './Http'
import {Result} from './Result'

export type Downloadable = Default | Loading | Failure

export interface Default {
    readonly type: 'Default'
}

export interface Loading {
    readonly type: 'Loading'
}

export interface Failure {
    readonly type: 'Failure'
    readonly error: HttpError
}

export function fromResult(result: Result<HttpError, null>): Downloadable {
    switch (result.type) {
        case 'Ok':
            return {type: 'Default'}
        case 'Err':
            return {type: 'Failure', error: result.error}
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Data/Downloadable.ts